import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
export function Toasts() {
  const {
    toasts,
    dismissToast
  } = useApp();
  return <div className="pointer-events-none fixed inset-x-0 bottom-24 z-[60] flex flex-col items-center gap-2 px-4 sm:bottom-6" data-id="element-462" data-mp="2gfhssmw4bld5">
      <AnimatePresence data-id="element-463" data-mp="2khl8xotqfe4r">
        {toasts.map(t => <motion.button key={t.id} type="button" onClick={() => dismissToast(t.id)} initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex max-w-sm items-center gap-2.5 rounded-lg border border-green-200 bg-white px-4 py-2.5 text-left text-sm text-ink shadow-pop" data-id="element-464" data-mp="3864g2111pkv9">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-green-500 text-white" data-id="element-465" data-mp="3vws1lp3vw90a">
              <CheckIcon className="h-3 w-3" data-id="element-466" data-mp="3u5ug3ebnqjc0" />
            </span>
            {t.besedilo}
          </motion.button>)}
      </AnimatePresence>
    </div>;
}